// 스크롤 막대가 자리를 차지하는 브라우저인지 문서 뿌리에 적는다
//
// ── 왜 있는가 ──────────────────────────────────────────────────────────────
//
// 고정줄의 KO/EN 은 같은 폭이면 화면이 바뀌어도 같은 x 에 서야 한다 (2026-10-15 사용자 「같은 자리로 고침」). 그런데 스크롤 막대가
// 자리를 차지하는 데스크톱 브라우저에서는 세로 스크롤이 있는 화면만 막대 폭만큼 문서가 좁아져, 가운데 맞춘 고정줄 열의 우측 끝이
// 옮긴다(세션 계측, 1280 에서 7.5px, 768 에서 15px). 막대 자리를 늘 비우면(`scrollbar-gutter: stable`) 이것이 사라진다.
//
// 그 규칙을 조건 없이 걸면 안 된다. 막대를 감추고 도는 헤드리스 Chromium(브라우저 검사와 대리 관측 촬영)에서도 그 규칙은 막대 폭만큼
// 자리를 비웠다(360 폭에서 KO/EN 이 우측 끝에서 16px 이 아니라 31px, 세션 계측 2026-10-15). 그대로 두면 검사와 촬영의 화면이 실제 폰보다
// 15px 좁아진다. 그래서 막대가 실제로 자리를 차지하는지를 한 번 재어
// 문서 뿌리에 `data-scrollbar="classic"` 을 적고, `src/web/index.css` 는 그 표시가 있을 때만 막대 자리를 비운다 (2026-10-15 세션
// 선택, 사용자 확인 안 함).
//
// 재는 법: 화면 밖에 `overflow: scroll` 상자 하나를 잠깐 두고 바깥 폭과 안쪽 폭의 차를 본다. 막대가 내용 위에 겹쳐 그려지는 폰과
// 막대를 감춘 브라우저에서는 0 이다.

/** 문서 뿌리에 적는 표시의 값. index.css 의 `:root[data-scrollbar='classic']` 규칙이 이 값을 읽는다. */
export const CLASSIC_SCROLLBAR = 'classic'

/** 스크롤 막대가 차지하는 폭(CSS px). 막대가 겹쳐 그려지거나 감춰져 있으면 0 이다. */
export function scrollbarWidth(doc: Document): number {
  const probe = doc.createElement('div')
  probe.style.cssText = 'position:absolute;top:-9999px;left:0;width:100px;height:100px;overflow:scroll;visibility:hidden'
  doc.body.append(probe)
  const width = probe.offsetWidth - probe.clientWidth
  probe.remove()
  return width
}

/** 막대가 자리를 차지하면 문서 뿌리에 표시를 단다. 진입점이 화면을 그리기 전에 한 번 부른다. */
export function markScrollbar(doc: Document): void {
  if (scrollbarWidth(doc) > 0) doc.documentElement.setAttribute('data-scrollbar', CLASSIC_SCROLLBAR)
}
